/**
 * NickName — renders displayName with optional nick icon (13x13) and nick color.
 * Used EVERYWHERE a user's display name is shown.
 *
 * Usage: <NickName user={message.author} className="text-sm" />
 */
import clsx from 'clsx';

interface NickNameUser {
  displayName?: string;
  nickIcon?: string | null;
  nickColor?: string | null;
  [key: string]: unknown;
}

interface Props {
  user: NickNameUser;
  fallback?: string;
  className?: string;
  /** Override default inline style */
  style?: React.CSSProperties;
}

export default function NickName({ user, fallback = '?', className, style }: Props) {
  const name = user?.displayName || fallback;
  const icon = user?.nickIcon;
  const color = user?.nickColor;

  return (
    <span
      className={clsx('inline-flex items-center gap-0.5', className)}
      style={{ ...style, ...(color ? { color } : {}) }}
    >
      {icon && (
        <img
          src={icon}
          alt=""
          width={13}
          height={13}
          className="flex-shrink-0"
          style={{ width: 13, height: 13 }}
        />
      )}
      <span className="truncate">{name}</span>
    </span>
  );
}
